module.exports = __webpack_public_path__ + "saira-light-webfont.1ab6eb9df774015c623e.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-light-webfont.woff
// module id = ../../../../../src/assets/fonts/saira-light-webfont.woff
// module chunks = styles